var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"pt-2 text-center"},[_vm._t("header")],2),_c('div',{staticClass:"mt-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }